import React,{useEffect} from 'react';
import { Routes, Route, Outlet } from "react-router-dom";
import { getClientApi } from '../../apis/userPermissionApi/userPermissionApi';


function HomePage() {
 
  useEffect(() => {

  }, [])


  return (
          <>
            <div className='errordiv'>
                <div className='error'>
                    <h1>Home Page</h1>
                </div>
            </div>
        </>
          
  );
}

export default HomePage;
